import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";

import { HttpclientService } from "../../../../shared";
import { Subject } from "rxjs";
import { GuidanceInsertRequest } from "./GuidanceInsertRequest";
import { GuidanceUpdateRequest } from "./GuidanceUpdateRequest";

@Injectable()
export class DataService_StudentGuidance {
	constructor(private http: HttpClient, private httpclientService: HttpclientService) {}

	//INSERT CUSTOM METHODS HERE
	GuidanceSelectList(PersonID) {
		var postResult$ = new Subject();
		var url = "Guidances/GuidanceSelectList?PersonID=" + PersonID;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	GuidanceInsert(parms: GuidanceInsertRequest) {
		var postResult$ = new Subject();
		var url = "Guidances/GuidanceInsert";

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	GuidanceUpdate(parms: GuidanceUpdateRequest) {
		var postResult$ = new Subject();
		var url = "Guidances/GuidanceUpdate";

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	DeleteGuidance(GuidanceID) {
		var postResult$ = new Subject();
		var url = "Guidances/DeleteGuidance?GuidanceID=" + GuidanceID;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}
}
